import PropTypes from 'prop-types';
import React from 'react';
import themes from '../../../utils/themes';
import {withLoadedUser} from '../../../login/containers/AuthBase';

export const withTheme = Component => {
  const WithTheme = ({currentUser, ...props}) => {
    const {role} = currentUser;
    const theme = role ? themes[role.toLowerCase()] : null;
    return <Component theme={theme} {...props} />;
  };

  WithTheme.propTypes = {
    currentUser: PropTypes.object,
  };

  return withLoadedUser(WithTheme);
};
